import { Routes, Route, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Home from '../Home/Home';
import Title from '../Title/Title';
import About from '../About/About';
import Contact from '../Contact/Contact';


const Main = ({ videoSelected, onVideo }) => {

    const [fade, setFade] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setFade(true);
        const timeout = setTimeout(() => setFade(false), 300);
        return () => clearTimeout(timeout);
    }, [location]);

    const handleMouseClick = (isSelected) => {
        videoSelected(isSelected);
    }

    return (
        <div className={`App ${fade ? 'fade' : ''}`}>
            {location.pathname === '/' &&  <Title />}

            <Routes location={location}>
                <Route path="/work" element={<Home onVideo={onVideo} videoSelected={handleMouseClick} />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </div>
    );
}

export default Main;